/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Error_ToastInputs */

const en_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error with activation.`)
};

const fr_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite lors de l'activation.`)
};

const de_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Aktivierung ist ein Fehler aufgetreten.`)
};

const it_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'attivazione.`)
};

const ru_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при активации.`)
};

const es_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un error con la activación.`)
};

const zh_cn2_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活过程中出现错误。`)
};

const ja_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーション中にエラーが発生しました。`)
};

const hi_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रियण में त्रुटि हुई।`)
};

const pt_pt2_login_offline_activation_error_toast = /** @type {(inputs: Login_Offline_Activation_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro na ativação.`)
};

/**
* | output |
* | --- |
* | "There was an error with activation." |
*
* @param {Login_Offline_Activation_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_error_toast = /** @type {((inputs?: Login_Offline_Activation_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_error_toast(inputs)
	if (locale === "de") return de_login_offline_activation_error_toast(inputs)
	if (locale === "it") return it_login_offline_activation_error_toast(inputs)
	if (locale === "ru") return ru_login_offline_activation_error_toast(inputs)
	if (locale === "es") return es_login_offline_activation_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_error_toast(inputs)
	if (locale === "ja") return ja_login_offline_activation_error_toast(inputs)
	if (locale === "hi") return hi_login_offline_activation_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_error_toast(inputs)
	return en_login_offline_activation_error_toast(inputs)
});